import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=cc22796e&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc22796e')) {
      api.createRecord('cc22796e', component.options)
    } else {
      api.reload('cc22796e', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=cc22796e&", function () {
      api.rerender('cc22796e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eJJdLrnD9b5Y/JS/comp/costHelpSixtyTage.vue"
export default component.exports